export function isRGBA(colorCssString: string) {
	return !!colorCssString.match(/rgba/gi);
}

export function getRGBDecimal(rgbString: string) {
	return rgbString.replace('rgba(', '').replace('rgb(', '').replace(')', '').split(',').map((y: any, i) => i <= 2 ? y / 255 : parseFloat(y));
}

export function getRGBStringFromArray(color: number[]) {
	// Returned value will be rgb not rgba. Ensure alpha is not included.
	color.length = 3;
	return `rgb(${color.map(x => Math.round(x * 255))})`;
}

export function getCompositeColor(matte: number[], transparentColor: number[]) {
	const target = [];
	target[0] = ((1 - transparentColor[3]) * matte[0]) + (transparentColor[3] * transparentColor[0]);
	target[1] = ((1 - transparentColor[3]) * matte[1]) + (transparentColor[3] * transparentColor[1]);
	target[2] = ((1 - transparentColor[3]) * matte[2]) + (transparentColor[3] * transparentColor[2]);

	return target;
}

export function getCompositeColors(colorStack: any[]) {
	if (!colorStack)
		return;
	const matte: any[] = colorStack[colorStack.length - 1];
	const transparentColor: any[] = colorStack[colorStack.length - 2];

	colorStack = colorStack.slice(0, -2);
	colorStack.push(getCompositeColor(matte, transparentColor));

	return colorStack.length === 1 ? getRGBStringFromArray(colorStack[0]) : getCompositeColors(colorStack);
}

export function getCompositeBgColor(el: Element, colorStack = []) {
	const color = getComputedStyle(el).backgroundColor;
	colorStack.push(color);
	if (isRGBA(color)) {
		if (el.parentElement)
			return getCompositeBgColor(el.parentElement, colorStack);
		else {
			// #32017: If no fully opaque color exists, ensure at least white is in the colorStack
			colorStack.push('rgba(255, 255, 255, 1)');
			return getCompositeColors(colorStack.map(x => getRGBDecimal(x)));
		}
	}
	else if (colorStack.length > 1)
		return getCompositeColors(colorStack.map(x => getRGBDecimal(x)));
	else
		return color;
}